/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import emailjs from 'emailjs-com';
import './Contact.css';
import fallbackBanner from '../../assets/contact-banner.jpg';
import { useContent } from '../../context/ContentContext';

const Contact = () => {
  const { siteContent, siteImages } = useContent();
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [subject, setSubject] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [error, setError] = React.useState('');
  const [showSubmitMessage, setShowSubmitMessage] = React.useState(false);
  const sendEmail = () => {
    if (!name) {
      setError('Please fill in your Name');
    } else if (!email) {
      setError('Please fill in your Email');
    } else if (!subject) {
      setError('Please fill in the Subject');
    } else if (!message) {
      setError('Please fill in your Message');
    } else {
      const templateParams = {
        name,
        subject,
        email,
        message,
      };

      emailjs.send('gmail', 'template_x5wd3f8', templateParams, 'user_SjJLJrXam9zwWyFHLbdCA')
        .then(() => {
          // console.log('SUCCESS!', response.status, response.text);
          setShowSubmitMessage(true);
          setName('');
          setEmail('');
          setMessage('');
          setSubject('');
        }, () => {
          // console.log('FAILED...', err);
        });
    }
  };
  return (
    <>
      {/* Alt text is empty because the photograph sets a mood above the form
          rather than saying anything a visitor needs to get in touch, and
          whatever is swapped in from Airtable has to stay described. */}
      <img
        className="contact-banner"
        src={siteImages.contact_image || fallbackBanner}
        alt=""
      />
      <div className="publications">
        <h2>{siteContent.contact_intro}</h2>
        <form className="mail-form">
          <div>Name*</div>
          <input type="text" value={name} onChange={(e) => { setName(e.target.value); setError(''); setShowSubmitMessage(false); }} className="mail-input" />
          <div>Email*</div>
          <input type="text" value={email} onChange={(e) => { setEmail(e.target.value); setError(''); setShowSubmitMessage(false); }} className="mail-input" />
          <div>Subject*</div>
          <input type="text" value={subject} onChange={(e) => { setSubject(e.target.value); setError(''); setShowSubmitMessage(false); }} className="mail-input" />
          <div>Message*</div>
          <textarea value={message} onChange={(e) => { setMessage(e.target.value); setError(''); setShowSubmitMessage(false); }} className="mail-input-area" />
          <div className="error-message">{error}</div>
          {showSubmitMessage
            ? <div className="submit-message">{siteContent.contact_success_message}</div>
            : null}
          <button type="button" className="submit-button" onClick={sendEmail}>
            {siteContent.contact_button_label}
          </button>
        </form>
      </div>
      {/* <div className="publications">
        <h2>Events</h2>
        <div className="pub-content">
          Presenter, Poetry Film Festival of Los Angeles, CA, 2023
        </div>
        <div className="pub-content">
          Reader, Poetry Panel at C.D. Wright Conference, University of Central
          Arkansas, Conway, AR, 2022
        </div>
        <div className="pub-content">
          Presenter, Generation Women, Joe’s Pub, Public Theater, New York, NY, 2022
        </div>
        <div className="pub-content">
          Paper presentation at The Society for Comparative Literature and Arts, Austin, Texas, 2021
        </div>
        <div className="pub-content">
          “Politics of Protest” Panel at South Central Modern Language Association, Houston, 2021
        </div>
        <div className="pub-content">
          Tin House Summer Workshop with Diana Khoi Ngyuen, 2021
        </div>
        <div className="pub-content">
          Action Optimism, Virtual talk and interview at Oxford Climate Society
          , University of Oxford, 2021
        </div>
        <div className="pub-content">
          Paper presentation at Global Souths Conference, University of Louisiana, Lafayette, 2021
        </div>
        <div className="pub-content">
          Reader, Hero Foundation Virtual Poetry Showcase for Charity, 2021
        </div>
        <div className="pub-content">
          Rewriting Gender in School System with Humans of Safe Places, 2020
        </div>
        <div className="pub-content">
          Reader, Lockdown Poetry Mic with Danish Hussain, 2020
        </div>
        <div className="pub-content">
          Poetry Panel Presentation at South Central Modern Language Association, Little Rock, 2019
        </div>
        <div className="pub-content">
          Reader, Dr. Grey’s Free Range Reading Series, Stellar Beans, Lake Charles, 2019
        </div>
        <div className="pub-content">
          Member of Association of Writers and Writing Program, 2018-2021
        </div>
        <div className="pub-content">
          Veganism and Sustainability with Chef Rakhee Vaswani, 2018
        </div>
        <div className="pub-content">
          Reader, Canvas Kavita #2, The Poetry Club, TARQ Art Gallery, Mumbai, 2016
        </div>
      </div> */}
    </>
  );
};

export default Contact;
